import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateMarvinAiReportMutationVariables = Types.Exact<{
  data: Types.MarvinCreateAiReportInput;
}>;


export type CreateMarvinAiReportMutationPage = { readonly __typename?: 'RootMutationType', readonly marvinCreateAiReport: boolean };

export type RequestAiReportsCountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RequestAiReportsCountMutationPage = { readonly __typename?: 'RootMutationType', readonly requestAiReportsCount: boolean };

export type StartAiMonitoringMutationVariables = Types.Exact<{
  data: Types.AiMonitoringConfigInput;
}>;


export type StartAiMonitoringMutationPage = { readonly __typename?: 'RootMutationType', readonly startAiMonitoring: { readonly __typename?: 'AiMonitoringConfig', readonly id: string, readonly status: Types.AiMonitoringStatus, readonly campaignSelectionMode: Types.CampaignSelectionMode, readonly campaignIds?: ReadonlyArray<number> | null, readonly campaignNameMask?: string | null, readonly attributionModel: Types.YalperAnalyticAttributionModelEnum, readonly kpi: Types.AiKpiType, readonly kpiValue: string, readonly budget?: string | null, readonly goals: ReadonlyArray<{ readonly __typename?: 'AiReportGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } };

export type StopAiMonitoringMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type StopAiMonitoringMutationPage = { readonly __typename?: 'RootMutationType', readonly stopAiMonitoring: { readonly __typename?: 'AiMonitoringConfig', readonly id: string, readonly status: Types.AiMonitoringStatus, readonly campaignSelectionMode: Types.CampaignSelectionMode, readonly campaignIds?: ReadonlyArray<number> | null, readonly campaignNameMask?: string | null, readonly attributionModel: Types.YalperAnalyticAttributionModelEnum, readonly kpi: Types.AiKpiType, readonly kpiValue: string, readonly budget?: string | null, readonly goals: ReadonlyArray<{ readonly __typename?: 'AiReportGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } };

export type UpdateAiMonitoringSettingsMutationVariables = Types.Exact<{
  data: Types.AiMonitoringConfigInput;
}>;


export type UpdateAiMonitoringSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly updateAiMonitoringSettings: { readonly __typename?: 'AiMonitoringConfig', readonly id: string, readonly status: Types.AiMonitoringStatus, readonly campaignSelectionMode: Types.CampaignSelectionMode, readonly campaignIds?: ReadonlyArray<number> | null, readonly campaignNameMask?: string | null, readonly attributionModel: Types.YalperAnalyticAttributionModelEnum, readonly kpi: Types.AiKpiType, readonly kpiValue: string, readonly budget?: string | null, readonly goals: ReadonlyArray<{ readonly __typename?: 'AiReportGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } };


export const CreateMarvinAiReportDocument = gql`
    mutation CreateMarvinAiReport($data: MarvinCreateAiReportInput!) {
  marvinCreateAiReport(data: $data)
}
    `;
export type CreateMarvinAiReportMutationFn = Apollo.MutationFunction<CreateMarvinAiReportMutationPage, CreateMarvinAiReportMutationVariables>;

/**
 * __useCreateMarvinAiReportMutation__
 *
 * To run a mutation, you first call `useCreateMarvinAiReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarvinAiReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarvinAiReportMutation, { data, loading, error }] = useCreateMarvinAiReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMarvinAiReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarvinAiReportMutationPage, CreateMarvinAiReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarvinAiReportMutationPage, CreateMarvinAiReportMutationVariables>(CreateMarvinAiReportDocument, options);
      }
export type CreateMarvinAiReportMutationHookResult = ReturnType<typeof useCreateMarvinAiReportMutation>;
export type CreateMarvinAiReportMutationResult = Apollo.MutationResult<CreateMarvinAiReportMutationPage>;
export type CreateMarvinAiReportMutationOptions = Apollo.BaseMutationOptions<CreateMarvinAiReportMutationPage, CreateMarvinAiReportMutationVariables>;
export const RequestAiReportsCountDocument = gql`
    mutation RequestAiReportsCount {
  requestAiReportsCount
}
    `;
export type RequestAiReportsCountMutationFn = Apollo.MutationFunction<RequestAiReportsCountMutationPage, RequestAiReportsCountMutationVariables>;

/**
 * __useRequestAiReportsCountMutation__
 *
 * To run a mutation, you first call `useRequestAiReportsCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAiReportsCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAiReportsCountMutation, { data, loading, error }] = useRequestAiReportsCountMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestAiReportsCountMutation(baseOptions?: Apollo.MutationHookOptions<RequestAiReportsCountMutationPage, RequestAiReportsCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAiReportsCountMutationPage, RequestAiReportsCountMutationVariables>(RequestAiReportsCountDocument, options);
      }
export type RequestAiReportsCountMutationHookResult = ReturnType<typeof useRequestAiReportsCountMutation>;
export type RequestAiReportsCountMutationResult = Apollo.MutationResult<RequestAiReportsCountMutationPage>;
export type RequestAiReportsCountMutationOptions = Apollo.BaseMutationOptions<RequestAiReportsCountMutationPage, RequestAiReportsCountMutationVariables>;
export const StartAiMonitoringDocument = gql`
    mutation StartAiMonitoring($data: AiMonitoringConfigInput!) {
  startAiMonitoring(data: $data) {
    id
    status
    campaignSelectionMode
    campaignIds
    campaignNameMask
    goals {
      id
      name
      counterId
      counterName
    }
    attributionModel
    kpi
    kpiValue
    budget
  }
}
    `;
export type StartAiMonitoringMutationFn = Apollo.MutationFunction<StartAiMonitoringMutationPage, StartAiMonitoringMutationVariables>;

/**
 * __useStartAiMonitoringMutation__
 *
 * To run a mutation, you first call `useStartAiMonitoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiMonitoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiMonitoringMutation, { data, loading, error }] = useStartAiMonitoringMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStartAiMonitoringMutation(baseOptions?: Apollo.MutationHookOptions<StartAiMonitoringMutationPage, StartAiMonitoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiMonitoringMutationPage, StartAiMonitoringMutationVariables>(StartAiMonitoringDocument, options);
      }
export type StartAiMonitoringMutationHookResult = ReturnType<typeof useStartAiMonitoringMutation>;
export type StartAiMonitoringMutationResult = Apollo.MutationResult<StartAiMonitoringMutationPage>;
export type StartAiMonitoringMutationOptions = Apollo.BaseMutationOptions<StartAiMonitoringMutationPage, StartAiMonitoringMutationVariables>;
export const StopAiMonitoringDocument = gql`
    mutation StopAiMonitoring($companyId: ID!) {
  stopAiMonitoring(companyId: $companyId) {
    id
    status
    campaignSelectionMode
    campaignIds
    campaignNameMask
    goals {
      id
      name
      counterId
      counterName
    }
    attributionModel
    kpi
    kpiValue
    budget
  }
}
    `;
export type StopAiMonitoringMutationFn = Apollo.MutationFunction<StopAiMonitoringMutationPage, StopAiMonitoringMutationVariables>;

/**
 * __useStopAiMonitoringMutation__
 *
 * To run a mutation, you first call `useStopAiMonitoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAiMonitoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAiMonitoringMutation, { data, loading, error }] = useStopAiMonitoringMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStopAiMonitoringMutation(baseOptions?: Apollo.MutationHookOptions<StopAiMonitoringMutationPage, StopAiMonitoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopAiMonitoringMutationPage, StopAiMonitoringMutationVariables>(StopAiMonitoringDocument, options);
      }
export type StopAiMonitoringMutationHookResult = ReturnType<typeof useStopAiMonitoringMutation>;
export type StopAiMonitoringMutationResult = Apollo.MutationResult<StopAiMonitoringMutationPage>;
export type StopAiMonitoringMutationOptions = Apollo.BaseMutationOptions<StopAiMonitoringMutationPage, StopAiMonitoringMutationVariables>;
export const UpdateAiMonitoringSettingsDocument = gql`
    mutation UpdateAiMonitoringSettings($data: AiMonitoringConfigInput!) {
  updateAiMonitoringSettings(data: $data) {
    id
    status
    campaignSelectionMode
    campaignIds
    campaignNameMask
    goals {
      id
      name
      counterId
      counterName
    }
    attributionModel
    kpi
    kpiValue
    budget
  }
}
    `;
export type UpdateAiMonitoringSettingsMutationFn = Apollo.MutationFunction<UpdateAiMonitoringSettingsMutationPage, UpdateAiMonitoringSettingsMutationVariables>;

/**
 * __useUpdateAiMonitoringSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAiMonitoringSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiMonitoringSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiMonitoringSettingsMutation, { data, loading, error }] = useUpdateAiMonitoringSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAiMonitoringSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiMonitoringSettingsMutationPage, UpdateAiMonitoringSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiMonitoringSettingsMutationPage, UpdateAiMonitoringSettingsMutationVariables>(UpdateAiMonitoringSettingsDocument, options);
      }
export type UpdateAiMonitoringSettingsMutationHookResult = ReturnType<typeof useUpdateAiMonitoringSettingsMutation>;
export type UpdateAiMonitoringSettingsMutationResult = Apollo.MutationResult<UpdateAiMonitoringSettingsMutationPage>;
export type UpdateAiMonitoringSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAiMonitoringSettingsMutationPage, UpdateAiMonitoringSettingsMutationVariables>;